import { PublicationStatus } from 'graphql.generated';
import { Saved_ListingFragment } from 'listing-details/queries/SavedListing.fragment.generated';
import { SavedListingSection } from 'listing-details/types';

export const getListingType = (
    listing: Saved_ListingFragment
): SavedListingSection | null => {
    if (!listing?.section) {
        return null;
    }
    if (
        ['for-sale', 'new-homes'].includes(listing.section) &&
        listing.category === 'residential'
    ) {
        return 'for-sale';
    } else if (
        listing.section === 'to-rent' &&
        listing.category === 'residential'
    ) {
        return 'to-rent';
    } else if (listing.category === 'commercial') {
        return 'commercial';
    } else if (listing.section === 'overseas') {
        return 'overseas';
    }
    return 'for-sale';
};

export const isLiveListing = (listing: Saved_ListingFragment) =>
    listing.publicationStatus === PublicationStatus.Live;
